import { render } from "./CanvasEngraver.vue?vue&type=template&id=38cafedb"
import script from "./CanvasEngraver.vue?vue&type=script&lang=js"
export * from "./CanvasEngraver.vue?vue&type=script&lang=js"
script.render = render

export default script